import React, { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Slot } from 'radix-ui'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useDuplicateScenarioMutation } from '@/entities/scenario'

import { ampli } from '@/shared/lib/ampli'

export const DuplicateScenario = ({
	scenarioId,
	children,
}: {
	scenarioId: string
	children: React.ReactNode
}) => {
	const { t } = useTranslation()

	const queryClient = useQueryClient()
	const duplicateScenarioMutation = useDuplicateScenarioMutation({
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['scenarios'],
			})
			queryClient.invalidateQueries({
				queryKey: ['scenarios-query-list'],
			})
		},
	})
	const duplicateScenario = useCallback(
		async (scenarioId: string) => {
			ampli.scenarioDuplicate()
			toast.promise(duplicateScenarioMutation.mutateAsync(scenarioId), {
				loading: t('duplicating.proccess', { defaultValue: 'Duplicating...' }),
				success: t('duplicating.success', {
					defaultValue: 'Duplicated successfully',
				}),
				error: t('duplicating.error', {
					defaultValue: 'Error while duplicating',
				}),
			})
		},
		[duplicateScenarioMutation]
	)

	return (
		<Slot.Root onClick={() => duplicateScenario(scenarioId)}>
			{children}
		</Slot.Root>
	)
}
